<template>
  <div
    :class="['rail-distance-cntr', { 'mirror-cntr': parkPosition === 'DX', 'rail-distance-cntr': parkPosition === 'SX' }, 'amber lighten-5']"
    :style="`width:${(100 * maxLengthTrue) / maxLengthFactor}%;min-width:${(600 * maxLengthTrue) / maxLengthFactor}px; left: 0%`"
  >
    <div
      v-for="(distanceMarker, index) in getRailIntervalList(lengthInterval)"
      :key="index"
      :class="'rail-distance' + (distanceMarker.mid ? ' mid-height' : ' long-height')"
      :style="`width:${distanceMarker.dm}%;font-size:${(((3 * maxLengthFactor) / 100) * lengthInterval) / maxLengthFactor}rem;`"
    >
      <span v-if="!distanceMarker.mid" :class="{ 'mirror-text': parkPosition === 'DX' }">
        {{ distanceMarker.length }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LengthMarker",
  props: {
    parkPosition: {
      type: String,
      default: "SX",
    },
    maxLengthFactor: {
      type: Number,
      default: 200,
    },
    maxLengthTrue: {
      type: Number,
      default: 200,
    },
    lengthInterval: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    getRailIntervalList(lengthInterval) {
      let lRes = this.maxLengthTrue;
      const resList = [];
      
      let dm = (100 * (lengthInterval / 2)) / this.maxLengthTrue;
      for (let i = 0; i < Math.round(this.maxLengthTrue / lengthInterval); i++) {
        // console.log("lRes >= lengthInterval", lRes, lengthInterval);
        if (lRes >= lengthInterval) {
          resList.push({
            dm: dm,
            length: lengthInterval * (i + 1) - lengthInterval / 2,
            mid: true,
          });
          resList.push({
            dm: dm,
            length: lengthInterval * (i + 1),
            mid: false,
          });
        } else {
          console.log("lRes", lRes);
          if (lRes/2 < lengthInterval/2) {
            resList.push({
              dm: dm,
              length: lengthInterval * (i + 1) - lengthInterval / 2,
              mid: true,
            });
          }
          resList.push({ dm: (100 * (lRes-(lengthInterval/2))) / this.maxLengthTrue, length: this.maxLengthTrue });
        }
        lRes -= lengthInterval;
      }
      return resList;
    },
  },
};
</script>

<style scoped>
.rail-distance {
  margin-bottom: 10px;
  float: left;
  border-right: 1px solid #aaaaaa;
  text-align: right;
  color: rgb(99, 99, 99);
  padding-right: 3px;
  padding-top: 25px;
}

.long-height {
  height: 45px;
  padding-top: 25px;
}

.mid-height {
  height: 20px;
  padding-top: 5px;
}

.rail-distance-cntr {
  z-index: 1;
  position: absolute;
  /* margin-top: 25px; */
}
.mirror-cntr {
  transform: scaleX(-1);
}
.mirror-text {
  transform: scaleX(-1);
  display: inline-block;
}
</style>
